import { Spin } from 'antd';
import { useLazyGetNewsQuery } from 'app/services/edpApiV1/news';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import NewsTable from 'features/tables/newsTable';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NewsTabs, SearchKeysNews } from 'shared/enums/news';
import { dataForNewsTable } from 'shared/helpers/utils';
import { INewsGetResponse, TNewsColumns, TSearchData } from 'shared/types/news.types';

const NewsPublicated = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const navigate = useNavigate();
  const { search } = useAppSelector(state => state.entities.search);
  const [result, setResult] = useState<INewsGetResponse[]>();
  const [total, setTotal] = useState<number>();
  const [searchData, setSearchData] = useState<TSearchData>({ key: SearchKeysNews.SEARCH_NAME, value: '' });

  const [getNewsLazy, resultAll] = useLazyGetNewsQuery();

  const onSearch = (data: string, key: SearchKeysNews) => {
    setSearchData({ key, value: data });
    getNewsLazy({ size: currentSize, page: currentPage, type: NewsTabs.PUBLICATED, [key]: data ? data : undefined });
  };

  useEffect(() => {
    setResult(resultAll.data?.data);
    setTotal(resultAll.data?.pagination.total);
  }, [resultAll]);

  useEffect(() => {
    getNewsLazy({
      size: currentSize,
      page: currentPage,
      type: NewsTabs.PUBLICATED,
      [searchData.key]: searchData.value ? searchData.value : undefined,
    });
  }, [currentPage, currentSize, getNewsLazy, search]);

  const onclickToRow = (id: number) => {
    navigate(`/news/info/${id}`);
  };

  const columns: TNewsColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
  ];
  return (
    <>
      <Spin spinning={resultAll.isFetching || resultAll.isLoading}>
        {result ? (
          <NewsTable
            dataSource={dataForNewsTable(result) || []}
            columns={columns}
            currentPage={currentPage}
            currentSize={currentSize}
            setCurrentPage={setCurrentPage}
            setCurrentSize={setCurrentSize}
            total={total}
            onclickToRow={data => onclickToRow(data)}
            onSearch={onSearch}
          />
        ) : null}
      </Spin>
    </>
  );
};

export default NewsPublicated;
